function calculateDifferenceWithTwoDecimalPlaces(referenceAmount, compareAmount) {
  const difference = compareAmount - referenceAmount;
  return parseFloat(Math.round(difference * 100) / 100);
}

export default calculateDifferenceWithTwoDecimalPlaces;
